import { registerContentBlock } from '../../content-blocks/register-content-block'
import BlockAdDivider from './BlockAdDivider.vue'
import BlockTableOfContent from './BlockTableOfContent.vue'
import BlockText from './BlockText.vue'
import BlockQuote from './BlockQuote.vue'
import BlockImage from './BlockImage.vue'
import BlockVideo from './video/BlockVideo.vue'
import BlockSeparator from './BlockSeparator.vue'
import BlockAccordion from './BlockAccordion.vue'
import BlockTable from './BlockTable.vue'
import BlockEmbed from './embed/BlockEmbed.vue'
import BlockTeaserGroup from './teaser/BlockTeaserGroup.vue'
import BlockIFrame from './BlockIFrame.vue'
import BlockNewsletterTeaser from './teaser/BlockNewsletterTeaser.vue'
import BlockContactForm from './BlockContactForm.vue'
import BlockListOfSources from './BlockListOfSources.vue'
import BlockChildTagsTeaserGroup from './teaser/BlockChildTagsTeaserGroup.vue'
import BlockInterline from './interline/BlockInterline.vue'
import AdaAutoNative from '../ad/AdaAutoNative.vue'
import BlockProductCard from './BlockProductCard.vue'
import BlockProductCardGroup from './BlockProductCardGroup.vue'
import BlockProductCardComparisonTable from './BlockProductCardComparisonTable.vue'
import BlockAd from './ad-block/BlockAd.vue'
import BlockVueComponent from './vue-components/BlockVueComponent.vue'
import BlockRelatedArticle from './related-article-block/BlockRelatedArticle.vue'
import BlockHeading from './BlockHeading.vue'
import BlockSectionTitle from './BlockSectionTitle.vue'
import BlockStructureTermTree from './BlockStructureTermTree.vue'
import BlockMediaGallery from './gallery/BlockMediaGallery.vue'

// Register default content blocks
export function registerDefaultContentBlocks () {
  // Register default content blocks
  registerContentBlock('adDividingLine', BlockAdDivider)
  registerContentBlock('tableOfContents', BlockTableOfContent)
  registerContentBlock('text', BlockText)
  registerContentBlock('quote', BlockQuote)
  registerContentBlock('image', BlockImage)
  registerContentBlock('horizontalLine', BlockSeparator)
  registerContentBlock('faq', BlockAccordion)
  registerContentBlock('table', BlockTable)
  registerContentBlock('embed', BlockEmbed)
  registerContentBlock('slider', BlockMediaGallery)
  registerContentBlock('interline', BlockInterline)
  registerContentBlock('teaserGroup', BlockTeaserGroup)
  registerContentBlock('pageableTeaserGroup', BlockTeaserGroup)
  registerContentBlock('iframe', BlockIFrame)
  registerContentBlock('newsletterTeaser', BlockNewsletterTeaser)
  registerContentBlock('contactForm', BlockContactForm)
  registerContentBlock('listOfSources', BlockListOfSources)
  registerContentBlock('childTagsTeaserGroup', BlockChildTagsTeaserGroup)
  registerContentBlock('video', BlockVideo)
  registerContentBlock('adaAutoNative', AdaAutoNative)
  registerContentBlock('vueComponent', BlockVueComponent)
  registerContentBlock('heading', BlockHeading)
  registerContentBlock('sectionTitle', BlockSectionTitle)
  registerContentBlock('structureTermTree', BlockStructureTermTree)

  // Register commerce blocks
  registerContentBlock('productCard', BlockProductCard)
  registerContentBlock('productCardGroup', BlockProductCardGroup)
  registerContentBlock('productCardComparisonTable', BlockProductCardComparisonTable)

  // Register dynamic ad blocks
  registerContentBlock('__injected_ad__', BlockAd)
  // Register dynamic related articles blocks
  registerContentBlock('__injected_related__', BlockRelatedArticle)
}
